<ng-template dsAttachTo="pageHeaderTitle">
  <h1 class="subheader-h1" role="heading" tabindex="0">Zdarzenia dla numeru KRS: {{krs}}</h1>
</ng-template>
<ds-button iconPos="left" icon="pi pi-arrow-left" severity="link"
           label="Powrót" (onClick)="goBack()"></ds-button>
<app-zdarzenia-filtry (pokazWczesniejszeEmitter)="pokazWczesniejsze($event)"></app-zdarzenia-filtry>
<app-zdarzenia-tabela [tabelaAktualne]="zdarzeniaAktualneLista"
                      [tabelaWczesniejsze]="zdarzeniaWczesniejszeLista"
                      [pokazTabeleWczesniejsze]="pokazZdarzeniaWczesniejsze">
</app-zdarzenia-tabela>
